import {
    SIGN_IN_REQUEST, SIGN_IN_SUCCESS, SIGN_IN_FAILURE,
    SIGN_IN_GUEST_REQUEST, SIGN_IN_GUEST_SUCCESS, SIGN_IN_GUEST_FAILURE,
    SIGN_UP_REQUEST, SIGN_UP_SUCCESS, SIGN_UP_FAILURE,
    GET_USERDATA_REQUEST, GET_USERDATA_SUCCESS, GET_USERDATA_FAILURE,
    LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE, SET_LOCATION
} from '../../actions/action-types';
import { isGuestDefaultLocation } from '../../../utils/locationDefaults';


const initialState = {
    userData: {},
    registration_response:[],
    SignIn: false,
    latitude: null,
    longitude: null,
    address: null,
    user_location: null,
    country_id: null,
    area: null
}

export const authReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        // For SIGN_IN
        case SIGN_IN_REQUEST:
            return {
                ...state, userData: {}, SignIn: false
            };
        case SIGN_IN_SUCCESS: {
            const hasGuestDefaultLocation = isGuestDefaultLocation(state.user_location);

            return {
                ...state,
                userData: payload?.data || {},
                SignIn: true,
                ...(hasGuestDefaultLocation
                    ? {
                        latitude: null,
                        longitude: null,
                        address: null,
                        user_location: null,
                        country_id: null,
                        area: null,
                    }
                    : {}),
            };
        }
        case SIGN_IN_FAILURE:
            return {
                ...state, userData: {}, SignIn: false,
            };

        case SIGN_IN_GUEST_REQUEST:
            return {
                ...state, userData: {}, SignIn: false,
            };
        case SIGN_IN_GUEST_SUCCESS:
            return {
                ...state,
                userData: {
                    ...(payload?.data || {}),
                    guest: true,
                    id: payload?.data?.id || payload?.data?.user_id || payload?.data?.guest_id || 'guest',
                    role_type: payload?.data?.role_type || 'GUEST',
                },
                SignIn: true,
            };
        case SIGN_IN_GUEST_FAILURE:
            return {
                ...state, userData: {}, SignIn: false,
            };

        // For Sign Up
        case SIGN_UP_REQUEST:
            return {
                ...state, registration_response: []
            }
        case SIGN_UP_SUCCESS:
            return {
                ...state, registration_response: payload?.data || [],
            }
        case SIGN_UP_FAILURE:
            return {
                ...state, registration_response: []
            }
        // For Logout
        case LOGOUT_REQUEST:
            return {
                ...state,
            }
        case LOGOUT_SUCCESS:
            return {
                ...state, userData: [], SignIn: false,
            }
        case LOGOUT_FAILURE:
            return {
                ...state,userData: [], SignIn: false,
                
            }

        // GET_USERDATA_MAIN_SCREEN
        case GET_USERDATA_REQUEST:
            return {
                ...state, userData: payload?.data
            }
        case GET_USERDATA_SUCCESS:
            return {
                ...state, userData: payload?.data
            }
        case GET_USERDATA_FAILURE:
            return {
                ...state, userData: [], SignIn: false,
            }
        case SET_LOCATION:
            return {
                ...state,
                user_location: payload,
                latitude: payload?.latitude,
                longitude: payload?.longitude,
                address: payload?.address,
                country_id: payload?.country_id ?? payload?.countryId ?? null,
                area: payload?.area ?? payload?.area_id ?? null
            }
        default:
            return state
    }
}
